var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('PageTitle',{attrs:{"title":"Skírteini"}}),_c('PageMenu',{attrs:{"route":"Certificates","selectedPage":_vm.page,"items":_vm.menu}}),(_vm.page === 'module')?_c('ModuleCertificate'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }